import { render } from "./HeaderComponent.vue?vue&type=template&id=5a530c48&scoped=true"
const script = {}

import "./HeaderComponent.vue?vue&type=style&index=0&id=5a530c48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a530c48"]])

export default __exports__